export default __webpack_public_path__ + "static/media/spinning-arrows.3d955fc6.gif";